import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";

// Componets
import HeaderHomepage from "./HeaderHomepage.js";
import RecruitmentProcess from "./RecruitmentProcess.js";
import ConsultantsBlock from "./ConsultantsBlock.js";
import ForCompanies from "./ForCompanies.js";
import ClientTestimonials from "./ClientTestimonials.js";
import OpportunitiesBlock from "./OpportunitiesBlock.js";
import LinkedinBlock from "./LinkedinBlock.js";

const StyledHomepage = styled(NanoFlex)`
  height: auto;
  padding: 0 50px 0px 50px;
  gap: 124px;

  @media only screen and (max-width: 815px) {
    padding: 0px 30px 0px 30px;
    gap: 84px;
  }

  .selectBtnBlock {
    padding: 0 10vw;
    .imgWrapper {
      width: 15vw;
      min-width: 325px;
    }
    .articlesBlock {
      .articlesBlockWrapper {
        .btnsContainer {
          .button {
            min-width: 230px;
          }
        }
      }
    }
  }

  .contactBlock {
    .contactFormWrapper {
      background-color: #f3b48b;
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    padding: 0px 20px 0px 20px;
  }
`;

export default class Homepage extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledHomepage flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"} data-aos="fade-up" data-aos-duration="1500">
        <HeaderHomepage />
        <RecruitmentProcess />
        <ConsultantsBlock />
        <ForCompanies />
        <OpportunitiesBlock />
        <ClientTestimonials />
        <LinkedinBlock />
      </StyledHomepage>
    );
  }
}
